import React from "react";
import styles from "../styles/organizationalStructure.module.css";
//翻譯
import { useTranslation } from "react-i18next";

const MarksForOrgStructure = [
  { id: 1, label: "Parent Company", color: "#2b3384" },
  { id: 2, label: "Level 1 Company", color: "#e6700f" },
  { id: 3, label: "Level 2 Company", color: "#f28c38" },
  { id: 4, label: "Level 3 Company", color: "#f6b179" },
  { id: 5, label: "Facility", color: "#4caf50" },
];

const MarksForUserStructure = [
  { id: 0, label: "Super Admin", color: "#1464c8", type: "category" },
  { id: 6, label: "Category", color: "#2b3384", type: "category" },
  { id: 1, label: "Parent Company", color: "#2b3384", type: "company" },
  { id: 2, label: "Level 1 Company", color: "#e6700f", type: "company" },
  { id: 3, label: "Level 2 Company", color: "#f28c38", type: "company" },
  { id: 4, label: "Level 3 Company", color: "#f6b179", type: "company" },
  { id: 5, label: "Facility", color: "#4caf50", type: "company" },
];

const OrgStructureTreeLegend = ({ tree, showInactive = true }) => {
  const { t } = useTranslation("OrgStructure");
  const isOrgTree = tree === "OrgStructure";
  const marks = isOrgTree ? MarksForOrgStructure : MarksForUserStructure;
  return (
    <div
      className={`${styles.legendWrapper} ${
        isOrgTree ? styles.orgTreeLegend : styles.userTreeLegend
      }`}
    >
      {marks.map((mark) => {
        const isCategory = !isOrgTree && mark.type === "category";
        return (
          <div key={mark.id} className={styles.legendItem}>
            <div
              className={`${styles.legendSquare} ${
                isCategory ? styles.categorySquare : ""
              }`}
              style={
                isCategory
                  ? { borderColor: mark.color }
                  : { backgroundColor: mark.color }
              }
            ></div>
            <div
              className={styles.legendLabel}
              //如果superAdmin要顯眼一點 
              //style={mark.label === "Super Admin" ? { color: mark.color } : {}}
            >
              {t(mark.label)}
            </div>
          </div>
        );
      })}
      {showInactive && <div className={styles.legendItem}>
        <div className={styles.legendSquare} style={{ background: "white", border: "2px dashed #6b7280" }} />
        <div className={styles.legendLabel}>{t("Inactive")}</div>
      </div>}
    </div>
  );
};

export default OrgStructureTreeLegend;
